import React, { Component } from 'react';
import styled from 'styled-components';

import ScrollAnimation from 'components/ScrollAnimation';
import Header from 'src/components/Header';
import Container from 'src/components/Container';
import ContentBlock from 'src/components/ContentBlock';
import Form from './elements/Form/Form';

class Register extends Component {
  render() {
    return (
      <Root>
        <Header
          image={require('src/assets/images/register/hero.jpg')}
          smallText={'Get in touch'}
          largeText={'Register'}
        />
        <ScrollAnimation>
          <ContentContainer>
            <ContentBlock
              title="Studio, 1, 2 &amp; 3 Bedroom Homes And Townhouses In New Westminster"
              body="Register today to be 33 storeys above it all, at 618 Carnarvon."
            />
            <FormWrapper id="DownArrow">
              <Form />
            </FormWrapper>
          </ContentContainer>
        </ScrollAnimation>
      </Root>
    );
  }
}

const Root = styled.main`
  overflow-x: hidden;
`;

const ContentContainer = styled(Container)`
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: -150px;
    right: -150px;
    width: 300px;
    height: 300px;
    background-image: url(${require('src/assets/images/register/circle.svg')});
    background-size: cover;
    z-index: -1;
  }
  &::after {
    content: '';
    position: absolute;
    top: 100px;
    left: -30px;
    width: 250px;
    height: 250px;
    background-image: url(${require('src/assets/images/register/circle.svg')});
    background-size: cover;
    z-index: -1;
  }
`;

const FormWrapper = styled.div`
  max-width: 720px;
  margin: 0 auto;
  margin-bottom: 235px;
  position: relative;
`;

export default Register;



// WEBPACK FOOTER //
// ./src/pages/Register/Register.js